import { PIN_MATERIAL_STATUS } from "@/constants/pinMaterialStatus";

// 判断采集的类型，用于埋点上报
export const ContentType = {
  art: "AI作品采集", // AI作品
  aigc: "aigc采集", //aigc 采集
  material: "素材采集", // 素材
  gather: "普通采集", // 普通采集
};

export const getContentType = (pin: IPin) => {
  if (pin?.extra?.art) {
    return ContentType.art;
  } else if (pin?.file_material?.status === PIN_MATERIAL_STATUS.AVAILABLE) {
    return ContentType.material;
  } else if (pin?.extra?.aigc === 1) {
    return ContentType.aigc;
  } else {
    return ContentType.gather;
  }
};
